<div class="row mx-0 question-modal" id="question">
  <div class="col-12 px-0 border-btm pb-3">
    <div class="pointer-cursor position-absolute right-align z-999">
      <img src="assets/images/close-movie.svg" alt="" (click)="close()" height="24" width="24">
    </div>

    <p class="mulish-normal text-xxs mb-1">{{'Question from' | translate}}</p>
    <div class=" row mx-0">
      <div class="col-12 col-lg-6 px-0 pr-5">
        <!-- <p class="mulish-normal text-xxs mb-1">{{'Question from' | translate}}</p> -->
        <div class="d-flex justify-content-between">
          <div class="d-flex filter-chip justify-content-center align-items-center px-2 py-1 mr-2 w-45" data-toggle="tooltip"
            title="{{selectedCountryExpedition | translate}}">
            <img [src]="selectedCountryImage" alt="" height="28">
            <p class="px-3 mulish-normal text-xxs mb-0">{{selectedCountryExpedition | translate}}</p>
          </div>
          <div class="d-flex filter-chip justify-content-center align-items-center px-2 py-1 mr-2  w-45" data-toggle="tooltip"
            title="{{selectedSdgExpedition | translate}}">
            <img [src]="selectedSdgImage" class="img-circle" alt="" height="28">
            <p class="px-3 mulish-normal text-xxs mb-0">{{selectedSdgExpedition | translate}}</p>
          </div>
          <!-- <div class="d-flex filter-chip justify-content-center align-items-center px-2 py-1 mr-2" data-toggle="tooltip"
            title="{{selectedSubjectExpedition | translate}}">
            <img src="assets/images/subject.svg" alt="" height="28">
            <p class="px-3 mulish-normal text-xxs mb-0">{{selectedSubjectExpedition | translate}}</p>
          </div> -->
        </div>
      </div>
      <div class="col-12 col-lg-6 px-0 pr-5">
        <div class="d-flex justify-content-around">
          <div class="">
            <div class="mulish-normal text-xxs mb-3">
              {{'Questions completed :' | translate}} {{questionStatus?.answered_questions}} /
              {{questionStatus?.total_questions}}
            </div>
            <div class="custom-progress">
              <div class="progress">
                <div class="progress-bar bg-primary" role="progressbar"
                  [style.width.%]="questionStatus?.attempted_percentage" aria-valuenow="12" aria-valuemin="0"
                  aria-valuemax="100"></div>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <img class="badge-img" *ngIf="questionStatus?.badge == 'None'" src="assets/images/no-badge.svg" alt="">
            <img class="badge-img" *ngIf="questionStatus?.badge == 'Bronze'" src="assets/images/bronze-badge.svg"
              alt="">
            <img class="badge-img" *ngIf="questionStatus?.badge == 'Silver'" src="assets/images/silver-badge.svg"
              alt="">
            <img class="badge-img" *ngIf="questionStatus?.badge == 'Gold'" src="assets/images/gold-badge.svg" alt="">
            <div class="pl-3 d-flex flex-column align-items-center">
              <p *ngIf="questionStatus?.badge !='None'" class="mulish-normal text-xxs mb-2">
                {{questionStatus?.badge | translate}}
              </p>
              <p *ngIf="questionStatus?.badge =='None'" class="mulish-normal text-xxs mb-2">
                {{'No badge yet' | translate}}
              </p>
              <div>
                <div class="score-chip mulish-bold text-xxs wd-max-content">
                  {{'Score :' | translate}} {{questionStatus?.score}} /
                  {{questionStatus?.maximum_score}}
                </div>
              </div>
            </div>

          </div>

        </div>


      </div>

    </div>


  </div>
  <div class="col-12 px-0 padding-top-24 modal-body-scroll" *ngIf="questionDetails">
    <div class="row mx-0">
      <div class="col-12 px-0">
        <div class="d-flex">
          <p class="text-16 mulish-800 mr-3">
            <!-- QNID 01 -->
            <!-- QN #{{questionIndex}} -->
            QN #{{questionDetails.question_number}}
          </p>
          <p class="text-xxs mulish-bold difficult-level-easy d-flex align-items-center justify-content-center px-3"
            *ngIf="questionDetails.difficulty == 1">{{'Easy' | translate}}</p>
          <p class="text-xxs mulish-bold difficult-level-medium d-flex align-items-center justify-content-center px-3"
            *ngIf="questionDetails.difficulty == 2">{{'Medium' | translate}}</p>
          <p class="text-xxs mulish-bold difficult-level-hard d-flex align-items-center justify-content-center px-3"
            *ngIf="questionDetails.difficulty == 3">{{'Hard' | translate}}</p>
        </div>
      </div>
      <div class="col-12 px-0">
        <p class="mulish-normal text-sm line-height-172 mb-0">{{questionDetails.title}}</p>
      </div>
      <div *ngIf="questionDetails.info_link" class="col-12 info-link rounded mt-3">
        <div class="px-3">
          <div class="row">
            <div class="col-12 col-lg-5 mulish-normal text-sm d-flex align-items-center">
              <img class="mr-3" src="./assets/images/link-green.svg" alt="">
              <div>{{'Kindly go through the URL to get more knowledge about the topic' | translate}}</div>
            </div>
            <div class="col-12 col-lg-7 bg-white d-flex align-items-center justify-content-between p-3 rounded text-xs">
              <div class="w-75 text-truncate">
                {{questionDetails.info_link}}
              </div>
              <a class="copy-icon" href="{{questionDetails.info_link}}" target="_blank">
                <div class="w-25 d-flex align-items-center justify-content-end font-wt-500">
                  <img class="mr-3 mb-1" src="./assets/images/copy.svg" alt="">
                  <div>{{'Visit URL' | translate}}</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 px-0 mb-4 padding-top-24" *ngIf="!correctAnswer && showQuestion">
        <div class="row mx-0">
          <div class="col-6 px-0" *ngIf="questionDetails.media_type != 1">
            <div class="video-notification">
              <img src="assets/images/idea.svg" alt="">
              <!-- <img [src]="questionDetails.image" alt=""> -->
              <p class="mulish-normal text-xxs pl-3 d-flex align-items-center mb-0"
                *ngIf="questionDetails.media_type == 3">
                {{'Watch a video before answering the question' | translate}}</p>
              <p class="mulish-normal text-xxs pl-3 d-flex align-items-center mb-0"
                *ngIf="questionDetails.media_type == 2">
                {{'View this image before answering the question' | translate}}</p>
            </div>

            <!-- video or img -->
            <div class="mt-4">
              <div *ngIf="questionDetails.media_type == 3" class='position-relative'>
                <!-- <iframe height="100%" width="100%" style="display: iframe;border-radius: 5px;"
                  [src]="'https://www.youtube.com/embed/3YOJvXcINGk' | safe" frameborder="0" allow='autoplay;'
                  allowfullscreen>
                </iframe> -->
                <div class="position-absolute d-flex align-items-center justify-content-center w-100 h-100">
                  <div (click)="playVideo()">
                    <img src="assets/images/play-icon.svg" alt="" class="play-icon">
                  </div>
                </div>
                <!-- <img src="assets/images/sample-image.png" alt="" class="image-wrapper w-100 h-100"> -->
                <img [src]="questionDetails.videoImage" alt="" class="image-wrapper w-100 h-100">
              </div>
              <div *ngIf="questionDetails.media_type == 2" class="position-relative">
                <div class="position-absolute d-flex align-items-center justify-content-center w-100 h-100">
                  <div
                    class="bg-danger d-flex text-white badge-custom align-items-center justify-content-center cursor-pointer mulish-bold text-13 view-image"
                    (click)="viewImage(questionDetails.image)">
                    <span> {{'View image' | translate | uppercase}} </span>
                    <mat-icon class="ml-3">fullscreen</mat-icon>
                  </div>
                </div>
                <!-- <img src="assets/images/sample-image.png" alt="" class="image-wrapper w-100 h-100"> -->
                <img [src]="questionDetails.image" alt="" class="image-wrapper w-100 h-100">


              </div>

            </div>
            <!-- /video or img -->

          </div>

          <!-- options -->
          <div class="col-6 px-0 " *ngIf="!view" [ngClass]="{'pl-5':questionDetails.media_type != 1}">
            <div *ngFor="let item of questionDetails.options; let i = index;">
              <div class="d-flex question-options mb-5 pointer-cursor option-shadow"
                [ngClass]="{'selected-option': item == selectedOption}"
                (click)="answerClicked(item,alphaIndex[i],questionDetails.id)">
                <p class="mulish-normal text-xxs font-5F5F5F mb-0 pr-3 wd-max-content">Option&nbsp;{{alphaIndex[i]}}</p>
                <p class="mulish-normal text-sm mb-0 text-break">{{item.description}}</p>
              </div>
            </div>
          </div>
          <div class="col-6 px-0 " *ngIf="view" [ngClass]="{'pl-5':questionDetails.media_type != 1}">
            <ng-container *ngFor="let item of questionDetails.options; let i = index;">
              <div class="d-flex question-options mb-5 max-wd-100"
                [ngClass]="{'show-right-answer': item.id == questionDetails.correct_option, 'wrong-answer-options': (item.id == questionDetails.selected_option) && (item.id != questionDetails.correct_option)}">
                <p class="mulish-normal text-xxs font-5F5F5F mb-0 pr-3 wd-max-content">Option&nbsp;{{alphaIndex[i]}}</p>
                <p class="mulish-normal text-sm mb-0 text-break">{{item.description}}</p>
              </div>
            </ng-container>
          </div>
          <!-- /options -->

        </div>
      </div>

      <!-- correct answer template  -->
      <div class="col-12 px-0 " *ngIf="correctAnswer && !showQuestion">
        <div class="text-center correct-answer">
          <img src="assets/images/correct-answer-star.svg" alt="">
          <p class="mulish-800 text-16">{{'Great! Your answer is correct!!' | translate}}</p>
          <p class="mulish-800 mt-4 text-28 font-green">
            {{'You got questionScore points' | translate :{questionScore: questionScore} }}
          </p>
          <p class="mulish-normal text-xxs" *ngIf="questionStatus?.badge != 'Gold'">
            {{'You’re just pointNeed more points away for upComingBadge badge' | translate :{pointNeed: pointNeed, upComingBadge: upComingBadge} }}
          </p>
          <div class="d-flex answer-options">
            <p class="mulish-normal text-xxs font-5F5F5F mb-0 pr-3 wd-max-content">
              Option&nbsp;{{correctOption.option}}
            </p>
            <p class="mulish-normal text-14 mb-0 text-break text-left">{{correctOption.description}}</p>
          </div>
          <p class="text-14 mulish-normal mt-4 answer-description" *ngIf="questionDetails?.feedback != null">
            {{questionDetails?.feedback}}
          </p>
        </div>

      </div>
      <!-- correct answer template  -->

      <!-- wrong answer template -->
      <div class="col-12 px-0" *ngIf="!correctAnswer && !showQuestion">
        <div class="text-center wrong-answer">
          <p class="text-16 mulish-800 "><b>{{'Oops! That was unfortunate!!' | translate}}</b></p>
          <div class="d-flex wrong-answer-options">
            <p class="mulish-normal text-xxs font-5F5F5F mb-0 pr-3 wd-max-content">
              Option&nbsp;{{selectedOption?.option}}</p>
            <p class="mulish-normal text-14 mb-0 text-break text-left">{{selectedOption?.description}}</p>
          </div>


        </div>
        <div class="text-center margin-top-24">
          <p class="text-14 mulish-800">{{'Correct answer was' | translate}},</p>
          <div class="d-flex show-right-answer">
            <p class="mulish-normal text-xxs font-5F5F5F mb-0 pr-3 wd-max-content">
              Option&nbsp;{{correctOption?.option}}
            </p>
            <p class="mulish-normal text-14 mb-0 text-break text-left">{{correctOption?.description}}</p>
          </div>
          <div>
            <p class="text-14 mulish-normal mt-4 answer-description" *ngIf="questionDetails?.hint != null">
              {{questionDetails?.hint}}
            </p>
          </div>


        </div>


      </div>
      <!-- wrong answer template -->

      <div class="col-12 px-0" *ngIf="!showQuestion && !data.isSingleQuestion">
        <div
          class="bg-danger d-flex text-white badge-custom align-items-center cursor-pointer mulish-bold text-13 continue-next-ques margin-top-24"
          (click)="continueNextQuestion()">
          <span *ngIf="unattendedQuestionsList.length != 0"> {{'Continue to next question' | translate | uppercase}}
          </span>
          <span *ngIf="unattendedQuestionsList.length == 0"> {{'Continue' | translate | uppercase}} </span>
          <mat-icon class="ml-3">arrow_right_alt</mat-icon>
        </div>

        <div class="py-2 px-3 flex-center  cursor-pointer mulish-bold  btn-block mb-3 margin-top-24 text-center mb-5"
          (click)="viewAllQuestion()">
          <div> {{'View all questions' | translate | uppercase}} </div>
          <mat-icon class="ml-3">arrow_right_alt</mat-icon>
        </div>

      </div>
      <div class="col-12 px-0" *ngIf="!showQuestion && data.isSingleQuestion">
        <div
          class="text-center bg-danger d-flex text-white badge-custom align-items-center cursor-pointer mulish-bold text-13 continue-next-ques margin-top-24 mb-5"
          (click)="close()">
          <span> {{'Continue' | translate | uppercase}} </span>
          <mat-icon class="ml-3">arrow_right_alt</mat-icon>
        </div>
      </div>

      <div class="col-12 px-0" *ngIf="showQuestion && !data.isSingleQuestion && unattendedQuestionsList.length > 1">
        <div
          class="py-2 px-3 flex-center next-qstn badge-custom cursor-pointer mulish-bold btn-light btn-block mb-5 border-light-custom"
          (click)="skipToNextQuestion()">
          <div> {{'Skip to next question' | translate | uppercase}} </div>
          <mat-icon class="ml-3">arrow_right_alt</mat-icon>
        </div>

      </div>

    </div>

  </div>

</div>
